import { signIn, signOut, useSession } from 'next-auth/react';
import { LogOut } from 'lucide-react';
import useTranslation from 'next-translate/useTranslation';
import Button from '@/components/@lushdigital/ui/button';

type SignInProps = {
  provider?: string;
  callbackUrl?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

type SignOutProps = {
  redirectTo?: string;
  theme?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export function SignIn({ provider = 'lush', callbackUrl, ...props }: SignInProps) {
  const { t } = useTranslation('tills');
  return (
    <Button fullWidth onClick={() => signIn('lush', { callbackUrl })} {...props}>
      {t('SIGN_IN')}
    </Button>
  );
}

export function SignOut({ redirectTo, ...props }: SignOutProps) {
  const { t } = useTranslation('tills');
  const { data: session } = useSession();

  const handleSignOut = async () => {
    // Get the idToken from the session before signing out
    const idToken = session?.idToken;

    // Construct the logout URL with the idToken
    const logoutUrl = `/api/logout?${new URLSearchParams({
      ...(idToken && { idToken }),
      ...(redirectTo && { redirectTo })
    }).toString()}`;

    // Sign out and redirect to our logout API route
    await signOut({ redirect: true, callbackUrl: logoutUrl });
  };

  return (
    <Button fullWidth onClick={handleSignOut} {...props}>
      <LogOut className="mr-2 h-4 w-4" />
      {t('SIGN_OUT')}
    </Button>
  );
}
